import React from 'react';

const HelpModal = ({ isDarkMode, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 animate-fade-in">
      <div className={`glass-card p-8 rounded-3xl shadow-2xl backdrop-blur-md border ${isDarkMode ? 'bg-gray-800/70 text-gray-100 border-gray-700' : 'bg-white/90 text-gray-900 border-gray-200'} w-11/12 max-w-lg transform scale-95 animate-scale-in`}>
        <div className="flex justify-between items-center mb-6">
          <h5 className={`font-['Orbitron'] font-bold text-xl ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>
            <i className="fas fa-question-circle mr-2"></i>Sistema de Ayuda
          </h5>
          <button 
            type="button" 
            className={`text-2xl ${isDarkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} 
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        <div className="mb-6">
          <h6 className={`text-lg font-bold mb-3 ${isDarkMode ? 'text-blue-300' : 'text-blue-500'}`}><i className="fas fa-info-circle mr-2"></i>Instrucciones:</h6>
          <ul className={`list-none pl-0 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
            <li className="mb-2"><i className="fas fa-arrow-right mr-2 text-green-500"></i>Ingresa un BIN usando 'x' para dígitos desconocidos</li>
            <li className="mb-2"><i className="fas fa-arrow-right mr-2 text-green-500"></i>Selecciona fecha de expiración y cantidad</li>
            <li className="mb-2"><i className="fas fa-arrow-right mr-2 text-green-500"></i>Modo Normal: hasta 10,000 tarjetas aleatorias</li>
            <li className="mb-2"><i className="fas fa-arrow-right mr-2 text-green-500"></i>Modo Ordenado: hasta 1,000 tarjetas secuenciales</li>
            <li className="mb-2"><i className="fas fa-arrow-right mr-2 text-green-500"></i>Haz clic en 'Generar' para crear los datos</li>
          </ul>
        </div>
        <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-yellow-900/30 border border-yellow-700 text-yellow-300' : 'bg-yellow-100 border border-yellow-400 text-yellow-800'}`}>
          <i className="fas fa-exclamation-triangle mr-2"></i>
          <strong>Importante:</strong> Usar responsablemente y solo para fines educativos.
        </div>
        <div className="text-right mt-6">
          <button 
            type="button" 
            className="btn-futuristic bg-gray-700 hover:bg-gray-600 text-white py-2 px-5 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105" 
            onClick={onClose}
          >
            <i className="fas fa-times mr-2"></i>Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;